import React, { memo } from "react";
import { List } from "@al/akui-mobile";

import { ProductDetailType } from "../../types";

import Coupon from "./Coupon";
import Standard from "./Standard";
import DeliverTo, { AddressProvinceItemType } from "./DeliverTo";
import PlatformGuarantee from "./PlatformGuarantee";
import styles from "./styles.scss";

type Props = {
  detail: ProductDetailType;
  addressList?: AddressProvinceItemType[];
};

export type { AddressProvinceItemType };

const Functions: React.FC<Props> = (props) => {
  const { detail, addressList = [] } = props;
  return (
    <div>
      <List className={styles.functions}>
        <Coupon detail={detail} />
        <Standard detail={detail} />
        <DeliverTo addressList={addressList} presellSupport={detail.presellSupport} />
      </List>
      <PlatformGuarantee presellSupport={detail.presellSupport} />
    </div>
  );
};

export default memo(Functions);
